import PropTypes from 'prop-types'

const sizePropTypes = {
  size: PropTypes.number,
}

const iconProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.6',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

export const MailIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...iconProps}>
    <rect x='2.5' y='5' width='19' height='14' rx='2' />
    <path d='M3.5 6.5 12 13l8.5-6.5' />
  </svg>
)
MailIcon.propTypes = sizePropTypes

export const ChartIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...iconProps}>
    <path d='M4 20V10' />
    <path d='M10 20V4' />
    <path d='M16 20v-7' />
    <path d='M4 20h16' />
  </svg>
)
ChartIcon.propTypes = sizePropTypes

export const PersonIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...iconProps}>
    <circle cx='12' cy='8' r='3.5' />
    <path d='M4.5 20c1-4 4.2-6 7.5-6s6.5 2 7.5 6' />
  </svg>
)
PersonIcon.propTypes = sizePropTypes

export const PhoneIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...iconProps}>
    <rect x='7' y='2.5' width='10' height='19' rx='2.2' />
    <line x1='10.5' y1='18.2' x2='13.5' y2='18.2' />
  </svg>
)
PhoneIcon.propTypes = sizePropTypes
